import { render, staticRenderFns } from "./assignUser.vue?vue&type=template&id=401cc6b1&scoped=true&"
import script from "./assignUser.vue?vue&type=script&lang=js&"
export * from "./assignUser.vue?vue&type=script&lang=js&"
import style0 from "./assignUser.vue?vue&type=style&index=0&id=401cc6b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cc6b1",
  null
  
)

export default component.exports